import authAxios from '@services/authAxios';

const fetchTemplateUpload = async () => {
    const { data } = await authAxios({
        method: 'GET',
        url: `/api/v1/template-upload/list`,
    });

    return data?.data;
};

export default fetchTemplateUpload;
